import { UseFormReturn } from 'react-hook-form';

import { BasicInfoForm } from './schema';
import { FormControl, FormField, FormItem, FormLabel, FormMessage } from '@/new/components/shadcn/form';
import { Input } from '@/new/components/shadcn/input';

interface BasicInfoStepProps {
  form: UseFormReturn<BasicInfoForm>;
}

export function MatterCreatorBasic({ form }: BasicInfoStepProps) {
  return (
    <div className="mx-auto w-full max-w-3xl px-3 py-6">
      <div className="my-8">
        <h2 className="font-serif text-xl font-medium">Basic Matter Information</h2>
      </div>

      <div className="space-y-6">
        <FormField
          control={form.control}
          name="name"
          render={({ field }) => (
            <FormItem>
              <FormMessage />
              <FormLabel required>Matter Name</FormLabel>
              <p className="-mt-0.5 mb-3 text-xs whitespace-normal text-gray-500">This can be updated later.</p>
              <FormControl>
                <Input {...field} placeholder="Company A vs Company B" data-testid="matter-creator-name-field" />
              </FormControl>
            </FormItem>
          )}
        />

        <hr className="my-10" />

        <FormField
          control={form.control}
          name="code"
          render={({ field }) => (
            <FormItem>
              <FormLabel>
                Matter Code <span className="font-normal text-gray-400">Optional</span>
              </FormLabel>
              <FormControl>
                <Input {...field} placeholder="WEX-123" data-testid="matter-creator-code-field" />
              </FormControl>
              <FormMessage />
            </FormItem>
          )}
        />

        <FormField
          control={form.control}
          name="tokenLimit"
          render={({ field }) => (
            <FormItem>
              <FormLabel>
                Matter Page Limit <span className="font-normal text-gray-400">Optional</span>
                <p className="mt-2 text-xs whitespace-normal text-gray-500">
                  The maximum number of pages that can be processed in this Matter before always requiring approval.
                </p>
              </FormLabel>

              <FormControl>
                <Input
                  {...field}
                  type="number"
                  data-testid="matter-creator-token-limit-field"
                  min="0"
                  step="1000"
                  onChange={(e) => field.onChange(e.target.value ? parseInt(e.target.value) : undefined)}
                  value={field.value ?? ''}
                />
              </FormControl>
              <FormMessage />
            </FormItem>
          )}
        />
      </div>
    </div>
  );
}
